/* ==========================================================================
   SOPHIA MAE - HEADER & ANNOUNCEMENT BAR & MENU DRAWER JAVASCRIPT
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {

  /* ========================================================================
     1. HAMBURGER MENU DRAWER TOGGLE
     - Toggles 'open-menu' class on <body> when clicking hamburger icon or close button
     ======================================================================== */
  const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusable(root) {
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE_SELECTOR), function (el) {
      return el.offsetParent !== null && !el.closest('[inert]');
    });
  }

  const menuDrawerEl = document.getElementById('MenuDrawer');
  const menuTrigger = document.querySelector('.header-cell--menu.js-menu-toggle') ||
                      document.querySelector('.js-menu-toggle');

  function setMenuTriggerState(isOpen) {
    if (!menuTrigger) return;
    menuTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const label = menuTrigger.dataset[isOpen ? 'labelClose' : 'labelOpen'];
    if (label) menuTrigger.setAttribute('aria-label', label);
  }

  function openMenuDrawer() {
    if (window.closeOtherDrawers) window.closeOtherDrawers(['open-menu']);
    document.body.classList.add('open-menu');
    setMenuTriggerState(true);
    if (menuDrawerEl) {
      menuDrawerEl.setAttribute('aria-hidden', 'false');
      setTimeout(function () { menuDrawerEl.focus(); }, 50);
    }
  }

  function closeMenuDrawer(restoreFocus) {
    if (!document.body.classList.contains('open-menu')) return;
    document.body.classList.remove('open-menu');
    setMenuTriggerState(false);
    if (menuDrawerEl) menuDrawerEl.setAttribute('aria-hidden', 'true');
    if (restoreFocus !== false && menuTrigger) menuTrigger.focus();
  }

  if (window.registerDrawerCloser) {
    window.registerDrawerCloser('open-menu', function () { closeMenuDrawer(false); });
  }

  const menuButtons = document.querySelectorAll('.js-menu-toggle, .header-cell--menu, .menu-burdger, .close-menu');
  menuButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (document.body.classList.contains('open-menu')) {
        closeMenuDrawer(true);
      } else {
        openMenuDrawer();
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (!document.body.classList.contains('open-menu')) return;

    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      closeMenuDrawer(true);
      return;
    }

    if (e.key !== 'Tab' || !menuDrawerEl) return;

    const focusable = getFocusable(menuDrawerEl);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (e.shiftKey) {
      if (active === first || active === menuDrawerEl) {
        e.preventDefault();
        last.focus();
      }
    } else if (active === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ========================================================================
     2. MULTI-LAYERED MENU DRAWER (SHOP / ABOUT TABS & LEVEL 1/2 NAVIGATION)
     ======================================================================== */
  const drawer = document.getElementById('MenuDrawer');
  if (drawer) {
    const tabsTrack = drawer.querySelector('.js-tabs-track');
    const panelsContainer = drawer.querySelector('.drawer-panels-container');
    const tabButtons = Array.from(drawer.querySelectorAll('.drawer-tab-btn'));
    const tabPanels = Array.from(drawer.querySelectorAll('.js-tab-panel'));

    const updateContainerHeight = function(targetPanel) {
      if (!panelsContainer || !targetPanel) return;

      // targetPanel is height:100% of panelsContainer, so reading its
      // scrollHeight while panelsContainer still holds the height of the
      // PREVIOUS panel/level just reports that stale value back (it can only
      // report a number >= the box's own current height). Briefly releasing
      // the explicit height lets targetPanel lay out at its true content size
      // for the measurement; nothing paints mid-script, so this doesn't
      // interfere with the CSS transition on panelsContainer's height.
      const previousHeight = panelsContainer.style.height;
      panelsContainer.style.height = 'auto';
      const contentHeight = targetPanel.scrollHeight;
      panelsContainer.style.height = previousHeight;

      if (contentHeight > 0) {
        const drawerRect = drawer.getBoundingClientRect();
        const tabsBar = drawer.querySelector('.drawer-tabs-bar');
        const tabsBarHeight = tabsBar ? tabsBar.offsetHeight : 40;

        // Calculate max available height in viewport below header and tabs bar
        const maxAvailable = window.innerHeight - drawerRect.top - tabsBarHeight - 20;

        // Only cap height if content actually exceeds available viewport height
        if (contentHeight > maxAvailable && maxAvailable > 150) {
          panelsContainer.style.height = maxAvailable + 'px';
        } else {
          panelsContainer.style.height = contentHeight + 'px';
        }
      }
    };

    // A. Tab Switcher (SHOP / ABOUT) with Synchronized Slider Track
    function selectTab(btn, moveFocus) {
      const targetIndex = parseInt(btn.dataset.tabIndex || 0, 10);
      const targetTabId = btn.dataset.tab;
      let activeTargetPanel = null;

      tabButtons.forEach(function (b) {
        const selected = b === btn;
        b.classList.toggle('is-active', selected);
        b.setAttribute('aria-selected', selected ? 'true' : 'false');
        b.setAttribute('tabindex', selected ? '0' : '-1');
      });

      tabPanels.forEach(panel => {
        if (panel.id === targetTabId) {
          panel.classList.add('is-active');
          panel.removeAttribute('inert');
          panel.scrollTop = 0;
          activeTargetPanel = panel;
          // Reset to Level 1 view when switching tabs
          const l1 = panel.querySelector('.js-level-1');
          const l2s = panel.querySelectorAll('.js-level-2');
          if (l1) {
            l1.classList.add('is-active');
            l1.classList.remove('is-back-anim');
          }
          l2s.forEach(l2 => l2.classList.remove('is-active'));
          panel.querySelectorAll('.js-open-level-2').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        } else {
          panel.classList.remove('is-active');
          panel.setAttribute('inert', '');
        }
      });

      if (tabsTrack) {
        tabsTrack.style.transform = 'translateX(' + (-targetIndex * 100) + '%)';
      }

      if (activeTargetPanel) {
        updateContainerHeight(activeTargetPanel);
      }

      if (moveFocus) btn.focus();
    }

    tabButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectTab(btn, false);
      });

      btn.addEventListener('keydown', function (e) {
        const currentIndex = tabButtons.indexOf(btn);
        let nextIndex = null;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % tabButtons.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
        } else if (e.key === 'Home') {
          nextIndex = 0;
        } else if (e.key === 'End') {
          nextIndex = tabButtons.length - 1;
        }

        if (nextIndex === null) return;
        e.preventDefault();
        selectTab(tabButtons[nextIndex], true);
      });
    });

    // B. Level 1 -> Level 2 Depth Navigation (Forward Slide: Enters from Right)
    const openLevel2Btns = drawer.querySelectorAll('.js-open-level-2');
    openLevel2Btns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const targetLayerId = btn.dataset.targetLayer;
        const currentPanel = btn.closest('.js-tab-panel');
        if (!currentPanel) return;

        const level1View = currentPanel.querySelector('.js-level-1');
        const targetLevel2View = currentPanel.querySelector('#' + CSS.escape(targetLayerId));

        if (level1View && targetLevel2View) {
          level1View.classList.remove('is-active', 'is-back-anim');
          targetLevel2View.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
          targetLevel2View._smReturnFocusTo = btn;

          const backBtn = targetLevel2View.querySelector('.js-back-to-level-1');
          if (backBtn) backBtn.focus();

          setTimeout(() => {
            updateContainerHeight(currentPanel);
          }, 10);
        }
      });
    });

    // C. Level 2 -> Level 1 Back Navigation (Backward Slide: Enters from Left)
    const backBtns = drawer.querySelectorAll('.js-back-to-level-1');
    backBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentLevel2View = btn.closest('.js-level-2');
        const currentPanel = btn.closest('.js-tab-panel');
        if (!currentPanel || !currentLevel2View) return;

        const level1View = currentPanel.querySelector('.js-level-1');
        if (level1View) {
          currentLevel2View.classList.remove('is-active');
          level1View.classList.add('is-active', 'is-back-anim');

          const returnTo = currentLevel2View._smReturnFocusTo ||
                           currentPanel.querySelector('.js-open-level-2[aria-controls="' + currentLevel2View.id + '"]');
          if (returnTo) {
            returnTo.setAttribute('aria-expanded', 'false');
            returnTo.focus();
          }

          setTimeout(() => {
            updateContainerHeight(currentPanel);
          }, 10);
        }
      });
    });

    // Initial height calculation when menu opens
    const menuToggles = document.querySelectorAll('.js-menu-toggle');
    menuToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        setTimeout(() => {
          const activePanel = drawer.querySelector('.js-tab-panel.is-active');
          if (activePanel) updateContainerHeight(activePanel);
        }, 50);
      });
    });
  }

  /* ========================================================================
     3. ANNOUNCEMENT BAR FUNCTIONALITY
     ======================================================================== */
  const bar = document.getElementById('HeaderAnnouncementBar');
  if (!bar) return;

  /* ------------------------------------------------------------------------
     A. Sticky on Scroll Toggle Handling
     - If block setting 'sticky_on_scroll' is OFF (false), hide announcement bar on scroll down
     ------------------------------------------------------------------------ */
  const isSticky = bar.dataset.sticky !== 'false';
  if (!isSticky) {
    const handleScroll = function() {
      if (window.scrollY > 20) {
        bar.classList.add('is-scrolled-hidden');
      } else {
        bar.classList.remove('is-scrolled-hidden');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  /* ------------------------------------------------------------------------
     B. Continuous Marquee (CSS animation - no slider, no per-slide transition)
     - All messages sit in one track that scrolls continuously
     - The message group is duplicated until it more than fills the bar, so the
       loop restarts off-screen: no visible jump and no empty gap between repeats
     - Movement itself is pure CSS; JS only measures widths so the speed stays
       constant regardless of how much copy the merchant enters
     ------------------------------------------------------------------------ */
  const content = bar.querySelector('.js-announcement-content');
  const track = bar.querySelector('.js-announcement-track');
  const group = bar.querySelector('.js-announcement-group');
  const pauseBtn = bar.querySelector('.js-announcement-pause');

  const announcementItems = group ? group.querySelectorAll('.js-announcement-item') : [];
  const itemCount = announcementItems.length;

  if (content && track && group && itemCount > 1) {
    const MARQUEE_SPEED = 35; // pixels per second (slower, smoother animation)

    const buildMarquee = function() {
      // Drop previously generated duplicates, keep the original group only
      track.querySelectorAll('.js-announcement-group-clone').forEach(function(clone) {
        clone.remove();
      });

      const groupWidth = group.getBoundingClientRect().width;
      if (!groupWidth) return;

      const visibleWidth = content.getBoundingClientRect().width || groupWidth;
      const copies = Math.max(2, Math.ceil(visibleWidth / groupWidth) + 1);

      for (let i = 1; i < copies; i++) {
        const clone = group.cloneNode(true);
        clone.classList.add('js-announcement-group-clone');
        clone.setAttribute('aria-hidden', 'true');
        // Duplicates are visual only - keep them out of the theme editor
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function(el) {
          el.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('[id]').forEach(function(el) {
          el.removeAttribute('id');
        });
        track.appendChild(clone);
      }

      // One full cycle = exactly one group width, so the wrap point is invisible.
      // Only the custom properties are set here - assets/header.css already
      // declares `animation: headerAnnouncementMarquee var(--marquee-duration,30s)
      // linear infinite` on .header-announcement-track by default, and reads
      // both vars live. Writing the `animation` shorthand here too (as this
      // used to) sets an INLINE style, and the `animation` shorthand always
      // resets every sub-property it doesn't mention - including
      // animation-play-state back to "running". An inline style beats a
      // non-!important stylesheet rule regardless of specificity, so that
      // inline write silently defeated `.header-announcement-bar.is-paused
      // .header-announcement-track{animation-play-state:paused}` below and
      // made the Pause/Play button (.js-announcement-pause) look broken.
      track.style.setProperty('--marquee-copies', copies);
      track.style.setProperty('--marquee-duration', (groupWidth / MARQUEE_SPEED).toFixed(2) + 's');
    };

    buildMarquee();

    // Re-measure once webfonts are applied (text width changes on font swap)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(buildMarquee);
    }

    let marqueeResizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(marqueeResizeTimer);
      marqueeResizeTimer = setTimeout(buildMarquee, 250);
    });

    /* ----------------------------------------------------------------------
       C. Pause / Play Button Event Handler
       - Toggles 'is-paused' on the bar, which pauses the CSS animation instantly
       ---------------------------------------------------------------------- */
    if (pauseBtn) {
      const prefersReducedMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let isPaused = prefersReducedMotion;
      pauseBtn.style.display = 'inline-flex';

      const syncPauseBtn = function () {
        bar.classList.toggle('is-paused', isPaused);
        const label = pauseBtn.dataset[isPaused ? 'labelPlay' : 'labelPause'];
        if (label) pauseBtn.setAttribute('aria-label', label);

        const pauseIcon = pauseBtn.querySelector('.icon-pause-wrap');
        const playIcon = pauseBtn.querySelector('.icon-play-wrap');
        if (pauseIcon) pauseIcon.style.display = isPaused ? 'none' : 'inline-block';
        if (playIcon) playIcon.style.display = isPaused ? 'inline-block' : 'none';
      };

      syncPauseBtn();

      pauseBtn.addEventListener('click', function() {
        isPaused = !isPaused;
        syncPauseBtn();
      });
    }
  } else {
    // 1 or 0 announcement blocks: disable animation, remove clones, hide pause button
    if (track) {
      track.style.animation = 'none';
      track.querySelectorAll('.js-announcement-group-clone').forEach(function(clone) {
        clone.remove();
      });
    }
    if (pauseBtn) {
      pauseBtn.style.display = 'none';
    }
  }

  /* ------------------------------------------------------------------------
     D. Close Button Event Handler (Smooth Animation)
     - Adds 'is-closed' class for smooth fade & collapse before hiding
     ------------------------------------------------------------------------ */
  const closeBtn = bar.querySelector('.js-announcement-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      bar.classList.add('is-closed');
      setTimeout(function() {
        bar.style.display = 'none';
      }, 400);
    });
  }

  const archiveAnnouncement = bar.querySelector('.js-archive-announcement');
  if (archiveAnnouncement) {
    const archiveStart = Number(archiveAnnouncement.dataset.start) * 1000;
    const archiveEnd = Number(archiveAnnouncement.dataset.end) * 1000;
    const archiveUpcoming = archiveAnnouncement.querySelector('.js-archive-announcement-upcoming');
    const archiveLive = archiveAnnouncement.querySelector('.js-archive-announcement-live');
    const archiveTimer = archiveAnnouncement.querySelector('.js-archive-announcement-timer');
    const archiveDays = archiveAnnouncement.querySelector('.js-archive-countdown-days');
    const archiveHours = archiveAnnouncement.querySelector('.js-archive-countdown-hours');
    const archiveMinutes = archiveAnnouncement.querySelector('.js-archive-countdown-minutes');
    const archiveSeconds = archiveAnnouncement.querySelector('.js-archive-countdown-seconds');
    let archiveTimerId;

    const padArchive = function(n) {
      return String(n).padStart(2, '0');
    };

    const tickArchive = function() {
      const now = Date.now();
      const isUpcoming = archiveStart > now;
      const activeText = isUpcoming ? archiveUpcoming : archiveLive;
      const target = isUpcoming ? archiveStart : archiveEnd;

      if ((archiveEnd && now >= archiveEnd) || !activeText) {
        clearInterval(archiveTimerId);
        bar.classList.add('is-closed');
        setTimeout(function() {
          bar.style.display = 'none';
        }, 400);
        return;
      }

      if (archiveUpcoming) archiveUpcoming.hidden = !isUpcoming;
      if (archiveLive) archiveLive.hidden = isUpcoming;
      archiveTimer.hidden = !target;

      if (!target) {
        clearInterval(archiveTimerId);
        return;
      }

      const remaining = target - now;
      archiveDays.textContent = padArchive(Math.floor(remaining / 86400000));
      archiveHours.textContent = padArchive(Math.floor((remaining % 86400000) / 3600000));
      archiveMinutes.textContent = padArchive(Math.floor((remaining % 3600000) / 60000));
      archiveSeconds.textContent = padArchive(Math.floor((remaining % 60000) / 1000));
    };

    archiveTimerId = setInterval(tickArchive, 1000);
    tickArchive();
  }
});

/* ========================================================================
   4. CUSTOM SORT DROPDOWN (COLLECTION & SEARCH) - Immediate Global Listener
   ======================================================================== */
document.addEventListener('click', function(e) {
  var sortDropdown = e.target.closest('.js-sort-dropdown');

  /* Click toggle button */
  var toggleBtn = e.target.closest('.js-sort-toggle');
  if (toggleBtn) {
    /* On pages with the collection filter drawer, the sort button opens
       the drawer's sorting accordion instead (handled in collection.js) */
    if (document.querySelector('.collection-filter-drawer')) {
      return;
    }
    e.preventDefault();
    var dropdown = toggleBtn.closest('.js-sort-dropdown');
    var list = dropdown ? dropdown.querySelector('.js-sort-list') : null;
    var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

    toggleBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    if (list) {
      list.classList.toggle('is-open');
    }
    return;
  }

  /* Click sort option */
  var optionBtn = e.target.closest('.js-sort-option');
  if (optionBtn) {
    e.preventDefault();
    var parentDropdown = optionBtn.closest('.js-sort-dropdown');
    if (!parentDropdown) return;

    var val = optionBtn.dataset.value;
    var name = optionBtn.textContent.trim();

    /* Update active state */
    var allOptions = parentDropdown.querySelectorAll('.js-sort-option');
    allOptions.forEach(function(btn) { btn.classList.remove('is-active'); });
    optionBtn.classList.add('is-active');

    /* Update displayed current option label */
    var labelEl = parentDropdown.querySelector('.js-sort-current-label');
    if (labelEl) labelEl.textContent = name;

    /* Close dropdown */
    var toggle = parentDropdown.querySelector('.js-sort-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var list = parentDropdown.querySelector('.js-sort-list');
    if (list) list.classList.remove('is-open');

    /* Trigger change on hidden native select for collection.js AJAX */
    var hiddenSelect = parentDropdown.querySelector('.collection-sort-select');
    if (hiddenSelect) {
      hiddenSelect.value = val;
      hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  /* Click outside closes any open sort dropdown */
  if (!sortDropdown) {
    document.querySelectorAll('.js-sort-dropdown').forEach(function(dd) {
      var btn = dd.querySelector('.js-sort-toggle');
      var lst = dd.querySelector('.js-sort-list');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (lst) lst.classList.remove('is-open');
    });
  }
});